<template>
  <div>
    <name-input
      v-if="currentStage === 'name'"
      :user="users"
      @idChanged="lookupComp"
      @start="startGame"
    />
    <template v-if="currentStage === 'game' && legNumber <= course.legs.length">
      <h3 class="font-main font-semibold text-2xl py-4 select-none">
        Leg: {{ legNumber }}
      </h3>
      <Game
        :key="legNumber"
        :settings="gameSettings"
        @finished="gameFinished"
        @nextLeg="nextLeg"
      />
    </template>

    <GameOver
      v-if="currentStage === 'finished'"
      :score="score"
      :time="time"
      :error="error"
    />
  </div>
</template>
<script>
import Game from '@/components/Game'
import NameInput from '@/components/NameInput'
import GameOver from '@/components/GameOver'

import Course from '@/assets/LockdownTeamCourse'

import firebase from 'firebase/app'
import 'firebase/firestore'

const db = firebase.firestore()

export default {
  components: {
    Game,
    NameInput,
    GameOver,
  },

  data: function() {
    return {
      course: Course,
      legNumber: 1,

      correct: [],
      times: [],
      paths: [],

      user: {},
      users: {},
      currentStage: 'name',
      error: 1,
    }
  },

  computed: {
    currentLeg: function() {
      return this.course.legs[this.legNumber - 1]
    },

    gameSettings: function() {
      return {
        ...this.currentLeg,
        showCorrectRoute: this.course.showSolution,
        hideMap: this.course.hideMap,
        penalty: this.course.penalty,
        timeLimit: this.course.timeLimit,
        undoButton: this.course.undoButton,
      }
    },

    score: function() {
      const penalty =
        this.times.filter(
          (time, index) =>
            time / 1000 > this.course.penalty && this.correct[index]
        ).length * 0.5
      const numberCorrect = this.correct.reduce((a, b) => a + b, 0)
      const score = numberCorrect - penalty

      return `${score}`
    },

    time: function() {
      return this.times.reduce((a, b) => a + b, 0)
    },
  },

  methods: {
    startGame: function(user) {
      this.currentStage = 'game'
      this.user = user
      this.setUserStarted(user.id)
    },

    gameFinished: function({ correct, path, time }) {
      this.correct.push(correct)
      this.times.push(time)
      this.paths.push(path)
    },

    nextLeg: function() {
      this.legNumber += 1

      if (this.legNumber > this.course.legs.length) {
        this.saveUserResult()
        this.currentStage = 'finished'
      }
    },

    lookupComp: async function(id) {
      try {
        this.users = await db
          .collection('teams')
          .doc(id.toString())
          .get()
          .then(result => ({ id, ...result?.data() }))
      } catch (error) {
        this.users = {}
      }
    },

    setUserStarted: function(userId) {
      return db
        .collection('teams')
        .doc(userId.toString())
        .update({ started: true })
    },

    saveUserResult: function() {
      return Promise.all([
        this.saveToMainDatabase({
          id: parseInt(this.user.id, 10),
          username: this.user.name.trim(),
          score: this.score.toString(),
          time: (this.time / 1000).toFixed(2).toString(),
        }),

        db
          .collection('teams')
          .doc(this.user.id.toString())
          .update({
            paths: JSON.stringify(this.paths),
            times: this.times,
            correct: this.correct,
            time: this.time,
            score: this.score,
          }),
      ])
        .then(() => {
          this.error = 0
        })
        .catch(err => {
          console.log(err)
          this.error = 2
        })
    },

    saveToMainDatabase: function(result) {
      return Promise.resolve()
    },
  },
}
</script>
